import { render, staticRenderFns } from "./gca.vue?vue&type=template&id=052ce251&"
import script from "./gca.vue?vue&type=script&lang=js&"
export * from "./gca.vue?vue&type=script&lang=js&"
import style0 from "./gca.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports